/* */ 
var anObject = require('./$.an-object'),
    get = require('./core.get-iterator-method');
module.exports = require('./$.core').getIterator = function(it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function')
    throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};
